import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import "./GoldenRunsDropdown.css";
import { getSheetDifficulty } from "./MiscComponents";
import { getContrastTextColor } from "../util/OtherUtils";
import { CrossIcon, DeathsIcon, GoldberryIcon, TextWithIcon, TimeIcon } from "./Icons";
import {
  formatClearDuration,
  getGoldenDescription,
  numberWithCommas,
} from "../pages/celeste-stats/StatsUtil";

export function GoldenRunsDropdown({ goldens }) {
  if (goldens === undefined || goldens === null || goldens.length === 0) return null;
  if (goldens.length === 1) return <GoldenRunDisplay golden={goldens[0]} doLink={true} />;

  //Sort by tier (hardest first), then by clear_duration descending. Goldens without a tier go to the end.
  const tierSort = (golden) => getSheetDifficulty(golden.sheet_difficulty_id)?.sort ?? -Infinity;
  goldens = goldens.sort((a, b) => {
    if (tierSort(a) !== tierSort(b)) return tierSort(b) - tierSort(a);
    return b.clear_duration - a.clear_duration;
  });

  const aggregateGolden = {
    id: "aggregate",
    description: "Total",
    cleared: goldens.every((golden) => golden.cleared),
    clear_duration: goldens.reduce((sum, golden) => sum + golden.clear_duration, 0),
    clear_deaths: goldens.reduce((sum, golden) => sum + golden.clear_deaths, 0),
    sheet_difficulty_id: goldens[0].sheet_difficulty_id,
  };
  return (
    <Dropdown>
      <Dropdown.Toggle as={GoldenRunDisplay} isToggle={true} golden={aggregateGolden} />
      <Dropdown.Menu>
        <Dropdown.ItemText>All Golden Runs</Dropdown.ItemText>
        {goldens.map((golden) => {
          return <Dropdown.ItemText key={golden.id} as={GoldenRunDisplay} golden={golden} doLink={true} />;
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}

//Other sizes: small, large
export function GoldenRunDisplay({ golden, className, doLink = false, isToggle = false, ...props }) {
  const tier = getSheetDifficulty(golden.sheet_difficulty_id) ?? {};
  const backgroundColor = tier.color ?? "white";
  const color = getContrastTextColor(backgroundColor);

  const clearedIcon = golden.cleared ? <GoldberryIcon style={{ marginBottom: "2px" }} /> : <CrossIcon />;
  const timeStr = formatClearDuration(golden.clear_duration);
  const deathsStr = numberWithCommas(golden.clear_deaths);
  const tierString = tier.name ?? "-";

  let description = getGoldenDescription(golden);
  //Remove the string "Golden" IF golden.description is null
  if (golden.description === null || golden.description === "" || golden.description === undefined) {
    description = description.replace("Golden", "").trim();
  }

  const isToggleClass = isToggle ? " golden-run-display-toggle" : "";

  const anchor = (
    <a
      className={className + " golden-run-display" + isToggleClass}
      style={{ backgroundColor: backgroundColor, color: color, border: "1px solid #888" }}
      role="button"
      href={doLink && golden.proof_url !== null ? golden.proof_url : undefined}
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      <div className="text-center clear">{clearedIcon}</div>
      <span className="text-center tier">{tierString}</span>
      <TextWithIcon className="time">
        <TimeIcon />
        {timeStr !== "" ? timeStr : "-"}
      </TextWithIcon>
      <TextWithIcon className="deaths">
        <DeathsIcon />
        {deathsStr !== "" ? deathsStr : "-"}
      </TextWithIcon>
      <span className="might-overflow description">{description}</span>
    </a>
  );

  if (golden.notes === null || golden.notes === "" || golden.notes === undefined) {
    return anchor;
  }

  return (
    <OverlayTrigger placement="right" overlay={<Tooltip>{golden.notes}</Tooltip>}>
      {anchor}
    </OverlayTrigger>
  );
}
